export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/8e8641da5546a83267ff7cb844712535.svg";